import { createStyles, makeStyles } from '@hawkins/styles';
export function timePickerInputStyles(theme) {
    var hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name of the `Card`. */
        card: {},
        /** Classname applied to the clear "X" button */
        clearBtn: {
            '& svg': {
                fontSize: '1em',
                height: '1em',
                width: 'auto',
            },
        },
        /** Class name of the end adornment icon. */
        endAdornmentIcon: {
            cursor: 'pointer',
        },
        /** Class name of the `FloatingUI`. */
        floatingUI: {
            margin: hawkinsVariables.spacings.space0,
            zIndex: hawkinsVariables.zIndexes.dropdown,
        },
        /** Class name of the root element. */
        root: {},
        /** Class name of the start adornment icon. */
        startAdornmentIcon: {
            cursor: 'pointer',
        },
        /** Class name of the start adornment icon when the component is disabled. */
        startAdornmentIconDisabled: {
            cursor: 'not-allowed',
        },
    });
}
export var useTimePickerInputStyles = makeStyles(timePickerInputStyles, { name: 'Hawkins-TimePickerInput' });
